import React, {useEffect} from 'react';
import stageConfig from 'app/StageConfig';

const {captchaSiteKey, environmentCookieDomain} = stageConfig;
const gtmId = environmentCookieDomain?.toLowerCase().includes('golan') ? 'GTM-N53QS8' : 'GTM-P2SNVT3';

const Script = ({id, src, async = false, defer = false, innerHTML, dataClsConfig}) => {
  useEffect(() => {
    if (id && document.getElementById(id)) return;
    const script = document.createElement('script');
    if (id) script.id = id;
    if (src) script.src = src;
    if (async) script.async = true;
    if (defer) script.defer = true; // <-- add this line
    if (innerHTML) script.innerHTML = innerHTML;
    if (dataClsConfig) script.setAttribute('data-clsconfig', dataClsConfig);
    document.head.appendChild(script);
  }, [id, src, async, defer, innerHTML, dataClsConfig]);
  return null;
};
const isDev = stageConfig.stage == 'dev';
const isProduction = stageConfig.stage == 'production';

export const ScriptManager = () => (
  <>
    {/* Accessibility Script (Pluro.ai) */}
    {!isDev && (
      <Script
        id='PluroAi_Accessibility'
        key='PluroAi_Accessibility'
        innerHTML={`
      (function() {
        var e = document.createElement('script');
        e.async = true;
        e.defer = true;
        e.setAttribute("type", "text/javascript");
        e.setAttribute("src", "https://my.pluro.ai/unitoolbar.js?lang=he");
        document.getElementsByTagName("head")[0].appendChild(e);
      })();
    `}
      />
    )}

    {/* Accessibility Script (User1st) */}
    {/* {!isDev && (
      <Script
        id='User1st_Snippet'
        key='User1st_Snippet'
        defer={true}
        innerHTML={`
        var _u1stSettings = {
          accessibilityBtn: {
            style: {
              desktop: [
                {background: 'none'},
                {'background-image': 'url(/Assets/accessibility.png)'},
                {'background-repeat': 'no-repeat'},
                {width: '35px'},
                {height: '32px'},
                {padding: '0px'},
                {position: 'fixed'},
                {right: 'initial'},
                {top: '175px'},
                {left: '0px'},
                {content: ''},
                {'font-size': '0px'},
                {color: 'transparent'},
              ],
              mobile: [
                {background: 'none'},
                {'background-image': 'url(/Assets/accessibility.png)'},
                {'background-repeat': 'no-repeat'},
                {width: '35px'},
                {height: '32px'},
                {padding: '0px'},
                {position: 'fixed'},
                {right: 'initial'},
                {top: '208px'},
                {left: '40px'},
                {content: ''},
                {'font-size': '0px'},
                {color: 'transparent'},
              ],
              tablet: [
                {background: 'none'},
                {'background-image': 'url(/Assets/accessibility.png)'},
                {'background-repeat': 'no-repeat'},
                {width: '35px'},
                {height: '32px'},
                {padding: '0px'},
                {position: 'fixed'},
                {right: 'initial'},
                {top: '208px'},
                {left: '0px'},
                {content: ''},
                {'font-size': '0px'},
                {color: 'transparent'},
              ],
            },
          },
          loading: { spa: 'angular' },
        };
        var isActive = /u1stIsActive=1/.test(document.cookie);
        var script = document.createElement('script');
        script.id = 'User1st_Loader';
        script.src = 'https://fecdn.user1st.info/Loader/head';
        !isActive && (script.defer = true);
        var documentPosition = document.head || document.documentElement;
        documentPosition.insertAdjacentElement('afterbegin', script);
      `}
      />
    )} */}
    {/* Google Tag Manager */}
    {!isDev && (
      <Script
        id={'gtmScriptId'}
        key={'gtmScriptId'}
        innerHTML={`
      (function(w,d,s,l,i){
        w[l]=w[l]||[];
        w[l].push({'gtm.start': new Date().getTime(), event:'gtm.js'});
        var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s), dl=l!='dataLayer'?'&l='+l:'';
        j.async=true;
        j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
        f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${gtmId}');
    `}
      />
    )}

    {/* Google reCAPTCHA */}
    <Script src={'https://www.google.com/recaptcha/api.js?render=' + captchaSiteKey} async id='script-5' key='script-5' />

    {/* Facebook Pixel */}
    {!isDev && (
      <Script
        id={'faceBookPixelScriptId'}
        key={'faceBookPixelScriptId'}
        innerHTML={`
      !(function(f,b,e,v,n,t,s){
        if(f.fbq)return;
        n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;
        n.push=n;
        n.loaded=!0;
        n.version='2.0';
        n.queue=[];
        t=b.createElement(e);t.async=!0;
        t.src=v;
        s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s);
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '3005613659481184');
      fbq('track', 'PageView');
    `}
      />
    )}

    {/* Glassbox CLS Detector */}
    {isProduction && (
      <Script
        id={'_cls_detector'}
        key={'_cls_detector'}
        src='https://cdn.glassboxcdn.com/poc/cellcom/p/detector-dom.min.js'
        async={true}
        dataClsConfig='reportURI=https://report.c1101.gbqofs.io/k5dlhazk/reporting/60c29e41-1dab-2a8d-0d1b-6be9c65cc9cf/cls_report;recordErrors=true;recordScrolls=true;recordMouseMoves=true;'
      />
    )}
  </>
);
